import { CircularProgress as MuiCircularProgress } from '@mui/material';

export function CircularProgress({ size, style, color, thickness }: {
  size?: number;
  style?: React.CSSProperties;
  color?: string;
  thickness?: number;
}) {
  return (
    <MuiCircularProgress
      size={size}
      style={style}
      sx={color ? { color } : undefined}
      thickness={thickness}
    />
  );
}

export default CircularProgress;
